import { getData, putData, postData } from "../api/api";

export type MailProvider = "CUSTOM_SMTP" | "OFFICE365_GRAPH";

export type MailSettings = {
  enabled: boolean;
  provider: MailProvider;
  host?: string;
  port: number;
  username?: string;
  passwordSet: boolean;
  fromAddress?: string;
  startTls: boolean;
  tenantId?: string;
  clientId?: string;
  clientSecretSet: boolean;
  allowedRecipientDomains: string[];
  configured: boolean;
  lastModifiedDate?: string;
  lastModifiedBy?: string;
};

export type MailSettingsSavePayload = {
  enabled: boolean;
  provider: MailProvider;
  host?: string;
  port: number;
  username?: string;
  /** Write-only; omit or blank to keep existing password. */
  password?: string;
  fromAddress?: string;
  startTls: boolean;
  tenantId?: string;
  clientId?: string;
  /** Write-only; omit or blank to keep existing client secret. */
  clientSecret?: string;
  allowedRecipientDomains: string[];
};

const BASE = "/admin/mail-settings";

export const mailSettingsService = {
  get: () => getData(BASE) as Promise<MailSettings>,
  save: (payload: MailSettingsSavePayload) =>
    putData(BASE, payload) as Promise<MailSettings>,
  sendTest: (to: string, subject?: string, body?: string) =>
    postData(`${BASE}/test`, { to, subject, body }) as Promise<{ ok: boolean }>,
};
